import { Currency } from '@/core/currency/interfaces';

const MGA: Currency = {
    name: 'Malagasy Ariary',
    demonym: 'Malagasy',
    majorSingle: 'Ariary',
    majorPlural: 'Ariary',
    codeNumeric: '969',
    symbol: 'Ar',
    symbolNative: 'Ar',
    minorSingle: 'Iraimbilanja',
    minorPlural: 'Iraimbilanja',
    ISOdigits: 2,
    decimals: 0,
    numToBasic: 5,
    code: 'MGA',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MGA;
